var _a;
import { RolePermission } from './role-permission';
import { UserRole } from './user-role.enum';
import { Principal } from '../principal.service';
var RolesWithPermissions = (_a = {},
    _a[UserRole.KN_ADMIN] = Object.keys(RolePermission),
    _a[UserRole.KN_FINANCE] = [
        RolePermission.RB_FINANCE,
        RolePermission.FINANCE_MODULE,
        RolePermission.MAIN_DASH_FINANCE,
        RolePermission.AD_UNITS_CREATE_UNIT,
        RolePermission.PUBLISHERS_ON_BOARDING_TABLE_APPROVE_REJECT,
        RolePermission.PUBLISHERS_ON_BOARDING_SCALED_PARTNERSHIP,
        RolePermission.PUBLISHERS_ON_BOARDING_SEND_WELCOME_EMAIL,
        RolePermission.PUBLISHERS_ON_BOARDING_IO_STATUS,
        RolePermission.AD_UNIT_FINANCE,
        RolePermission.AD_UNIT_OPTIMIZATIONS,
        RolePermission.PUBLISHERS_PUBLISHERS_EDIT_SALES_REP_SELECTION,
        RolePermission.PUBLISHERS_PUBLISHERS_DFP_INFORMATION,
        RolePermission.SITE_APPROVAL_TABLE_APPROVE_REJECT,
        RolePermission.SITE_APPROVAL_PUBLISHER_MODAL_SALES_REP_SELECTION,
        RolePermission.SITE_APPROVAL_IAS_EXPORT_IMPORT,
    ],
    _a[UserRole.KN_SALES_PERSON] = [
        RolePermission.MAIN_DASH_FINANCE,
        RolePermission.RB_FINANCE,
        RolePermission.AD_UNITS_MODULE,
        RolePermission.PUBLISHERS_MODULE,
        RolePermission.SITE_APPROVAL_MODULE,
        RolePermission.SUPPORT_MODULE,
    ],
    _a[UserRole.KN_OPERATIONS] = [
        RolePermission.MAIN_DASH_FINANCE,
        RolePermission.BLOCKS_MODULE,
        RolePermission.RB_FINANCE,
        RolePermission.ANALYTICS_MODULE,
        RolePermission.PUBLISHERS_MODULE,
        RolePermission.USERS_MODULE,
        RolePermission.AD_UNITS_MODULE,
        RolePermission.UNIT_REQUESTS_MODULE,
        RolePermission.ADS_TXT_MODULE,
        RolePermission.WIDGETS_MODULE,
        RolePermission.SUPPORT_MODULE,
        RolePermission.SITE_APPROVAL_MODULE,
        RolePermission.DEMAND_PARTNER_MODULE,
        RolePermission.AD_UNITS_CREATE_UNIT,
        RolePermission.PUBLISHERS_ON_BOARDING_TABLE_APPROVE_REJECT,
        RolePermission.PUBLISHERS_ON_BOARDING_SCALED_PARTNERSHIP,
        RolePermission.PUBLISHERS_ON_BOARDING_SEND_WELCOME_EMAIL,
        RolePermission.PUBLISHERS_ON_BOARDING_IO_STATUS,
        RolePermission.PUBLISHERS_PUBLISHERS_EDIT_SALES_REP_SELECTION,
        RolePermission.PUBLISHERS_PUBLISHERS_DFP_INFORMATION,
        RolePermission.SITE_APPROVAL_TABLE_APPROVE_REJECT,
        RolePermission.SITE_APPROVAL_PUBLISHER_MODAL_SALES_REP_SELECTION,
        RolePermission.SITE_APPROVAL_IAS_EXPORT_IMPORT,
        RolePermission.AD_UNIT_FINANCE,
        RolePermission.AD_UNIT_OPTIMIZATIONS,
    ],
    _a[UserRole.KN_ACCOUNT_MANAGER] = [
        RolePermission.PUBLISHERS_MODULE,
        RolePermission.USERS_MODULE,
        RolePermission.AD_UNITS_MODULE,
        RolePermission.UNIT_REQUESTS_MODULE,
        RolePermission.ADS_TXT_MODULE,
        RolePermission.WIDGETS_MODULE,
        RolePermission.AD_UNITS_CREATE_UNIT,
        RolePermission.PUBLISHERS_ON_BOARDING_TABLE_APPROVE_REJECT,
        RolePermission.PUBLISHERS_ON_BOARDING_SCALED_PARTNERSHIP,
        RolePermission.PUBLISHERS_ON_BOARDING_SEND_WELCOME_EMAIL,
        RolePermission.PUBLISHERS_ON_BOARDING_IO_STATUS,
        RolePermission.PUBLISHERS_PUBLISHERS_EDIT_SALES_REP_SELECTION,
        RolePermission.PUBLISHERS_PUBLISHERS_DFP_INFORMATION,
        RolePermission.SITE_APPROVAL_TABLE_APPROVE_REJECT,
        RolePermission.SITE_APPROVAL_PUBLISHER_MODAL_SALES_REP_SELECTION,
        RolePermission.SITE_APPROVAL_IAS_EXPORT_IMPORT,
        RolePermission.AD_UNIT_FINANCE,
        RolePermission.AD_UNIT_OPTIMIZATIONS,
    ],
    _a);
var RolePermissionService = /** @class */ (function () {
    function RolePermissionService(principal) {
        this.principal = principal;
    }
    RolePermissionService.prototype.hasPermissions = function (permissions) {
        var roles = this.principal.getUser()._roles;
        if (permissions && permissions.length) {
            if (roles) {
                return roles.some(function (role) {
                    var permissionsForRole = RolesWithPermissions[role];
                    return permissionsForRole && permissionsForRole.some(function (p) { return permissions.includes(p); });
                });
            }
        }
        return false;
    };
    return RolePermissionService;
}());
export { RolePermissionService };
